var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.81395C3 5.15528 5.15528 3 7.81395 3H16.186C18.8447 3 21 5.15528 21 7.81395V16.186C21 18.8447 18.8447 21 16.186 21H7.81395C5.15528 21 3 18.8447 3 16.186V7.81395ZM13.1677 11.1627C13.1677 10.7485 12.8319 10.4127 12.4177 10.4127L10.7433 10.4127C10.3291 10.4127 9.99328 10.7485 9.99328 11.1627C9.99328 11.577 10.3291 11.9127 10.7433 11.9127H11.6677V16.186C11.6677 16.6002 12.0035 16.936 12.4177 16.936C12.8319 16.936 13.1677 16.6002 13.1677 16.186V11.1627ZM13.1677 7.81388C13.1677 7.39967 12.8319 7.06388 12.4177 7.06388C12.0035 7.06388 11.6677 7.39967 11.6677 7.81388V8.65109C11.6677 9.0653 12.0035 9.40109 12.4177 9.40109C12.8319 9.40109 13.1677 9.0653 13.1677 8.65109V7.81388Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.f71bb56c4788bd338207566e354ade6f.svg";
export { ForwardRef as ReactComponent };